module.exports = __webpack_public_path__ + "img/search-glass.38b0bc24.svg";